import * as React from 'react';

import styled, { useTheme } from 'styled-components';

export interface DefaultAvatarProps {
  className?: string;
  color?: string;
}

export const DefaultAvatar: React.FC<DefaultAvatarProps> = (props) => {
  const theme = useTheme();

  const getColor = (color: any) => {
    switch (color) {
      case 'red':
        return { icon: theme.colors.primary, background: theme.colors.accent };
      default:
        return { icon: theme.colors.accent, background: theme.colors.primary };
    }
  };

  const fillColor = getColor(props.color);

  return (
    <svg className={props.className} x="0px" y="0px" viewBox="0 0 100 100">
      <rect fill={fillColor.background} width="100" height="100" />
      <path
        fill={fillColor.icon}
        d="M62.1,48.6L45.7,32v16.6L30,32v28.1l7.8,7.9l0-16.6L54.3,68V51.4L70,68V39.9L62.1,32V48.6z"
      />
    </svg>
  );
};

export default styled(DefaultAvatar)`
  border-radius: 50%;
  aspect-ratio: 1 / 1;
`;
